import React from 'react';
import { Filter } from 'react-admin';

import { FILTER_EMPTY_VALUE } from 'src/constants';
import { ShsSearchInput, ShsSelectInput, ShsAutoCompleteWithLoad } from 'src/components/common';
import {
    ChildrenFilterManager,
    EDUCATION_CENTER_ID,
    EDUCATION_LEVEL_GRADE,
    EDUCATION_LEVELS,
    PRESCHOOL_EDUCATION_LEVEL
} from 'src/managers/Children/ChildrenFilterManager';

interface FiltersProps {
    showEducationCenterFilter?: boolean;
}

const filterDropdownEmptyText = 'Усі';

const isAdmin = ChildrenFilterManager.isAdmin();
const isPreSchool = ChildrenFilterManager.isPreSchool();
const isJuniorSchool = ChildrenFilterManager.isJuniorSchool();
const isHighSchool = ChildrenFilterManager.isHighSchool();
const isSpecial = ChildrenFilterManager.isSpecial();
const isPsychologist = ChildrenFilterManager.isPsychologist();

const Filters: React.FC<FiltersProps> = ({ showEducationCenterFilter }) => (
    <Filter>
        <ShsSearchInput source="keyword" label="Знайти дитину" alwaysOn />
        {showEducationCenterFilter && (
            <ShsAutoCompleteWithLoad
                source={EDUCATION_CENTER_ID}
                pageUrl="centers"
                filters={{ isActive: true }}
                emptyValue={FILTER_EMPTY_VALUE}
                emptyText={filterDropdownEmptyText}
                alwaysOn
                keyField="id"
                textField="shortName"
                resultLimit={100}
                label="Освітній центр"
            />
        )}
        {(isSpecial || isPsychologist || isAdmin) && (
            <ShsSelectInput
                // this source is used ONLY here in filters
                source={EDUCATION_LEVELS}
                label="Рівень освіти"
                alwaysOn
                emptyValue={FILTER_EMPTY_VALUE}
                emptyText={filterDropdownEmptyText}
                choices={ChildrenFilterManager.getEducationLevelChoices()}
            />
        )}
        {(isJuniorSchool || isHighSchool || isAdmin) && (
            <ShsSelectInput
                // this source is used ONLY here in filters
                source={EDUCATION_LEVEL_GRADE}
                label="Клас"
                alwaysOn
                emptyValue={FILTER_EMPTY_VALUE}
                emptyText={filterDropdownEmptyText}
                choices={ChildrenFilterManager.getEducationLevelGradeChoices()}
            />
        )}

        {(isPreSchool || isAdmin) && (
            <ShsSelectInput
                // this source is used ONLY here in filters
                source={PRESCHOOL_EDUCATION_LEVEL}
                label="Вік"
                alwaysOn
                emptyValue={FILTER_EMPTY_VALUE}
                emptyText={filterDropdownEmptyText}
                choices={ChildrenFilterManager.getPreSchoolChoices()}
            />
        )}
    </Filter>
);

export default Filters;
